module.exports = __webpack_public_path__ + "img/car_shina2_20.bcf4bd86.jpg";